exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-bg-primary-600{background-color:#34668c}.vc-rounded-full{border-radius:0}", ""]);

// exports
